// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"Icons_iconContainer__1JVLG","icon":"Icons_icon__28lPO","horizontalMobile":"Icons_horizontalMobile__Rbxni"};